import { SWReactCountryIcons } from "@similarweb/icons";
import type { BaseCellProps } from "@similarweb/pro-logic-components";

import { DATA_AUTOMATION_SINGLE_COUNTRY_VALUE } from "../const";
import { StyledSignleLocationBaseCell, StyledCountryFlagContainer } from "../styles";

type Props = { countryCode: number } & BaseCellProps;

const SingleCountryCell = ({ countryCode, children, dataAutomation, ...baseCellProps }: Props) => {
    return (
        <StyledSignleLocationBaseCell
            {...baseCellProps}
            dataAutomation={dataAutomation ?? DATA_AUTOMATION_SINGLE_COUNTRY_VALUE}
        >
            <StyledCountryFlagContainer>
                <SWReactCountryIcons
                    countryCode={countryCode}
                    size="xs"
                />
            </StyledCountryFlagContainer>

            {children}
        </StyledSignleLocationBaseCell>
    );
};

export default SingleCountryCell;
